export const config = {
  title: 'Vendor Share',
  maxVendorSelect: 1000,
  defaultTab: 'myVendor',
  defaultPageSize: 10,
  vendorTabs: [
    { key: 'myVendor', label: 'My Vendors' },
    { key: 'allVendor', label: 'All Vendors' },
  ],
  vendorColumns: [
    { title: 'Vendor Name', dataIndex: 'vendorName', key: 'vendorName' },
    { title: 'Email', dataIndex: 'vendorEmail', key: 'vendorEmail' },
    { title: 'Location', dataIndex: 'vendorLocation', key: 'vendorLocation' },
    { title: 'Updated On', dataIndex: 'updatedOn', key: 'updatedOn' },
  ],
};
